import { PageCardGrid } from "./PageCardGrid";

export const PageInfoSkeleton = () => {
  return (
    <div className="h-full w-full">
      <PageCardGrid>
        {[1, 2, 3, 4, 5, 6].map((item) => (
          <div
            key={item}
            className="animate-pulse overflow-hidden rounded-lg border border-neutral-200"
          >
            <div className="h-24 bg-neutral-300" />
            <div className="p-4">
              <div className="mb-3 h-6 w-3/4 rounded bg-neutral-300" />
              <div className="mb-2 h-4 w-full rounded bg-neutral-200" />
              <div className="h-4 w-2/3 rounded bg-neutral-200" />
              <div className="mt-4 h-4 w-1/3 rounded bg-neutral-200" />
            </div>
          </div>
        ))}
      </PageCardGrid>
    </div>
  );
};
